import produce from 'immer';

// UTILS
import { toSelect } from 'utils/genericFunctions';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, TiposChavePix } from './types';

export const INITIAL_STATE: TiposChavePix = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): TiposChavePix {
	return produce(state, draft => {
		switch (action.type) {
			case Types.TIPOS_CHAVE_PIX_REQUEST: {
				break;
			}
			case Types.TIPOS_CHAVE_PIX_SUCCESS: {
				draft.status = 200;
				const select = toSelect(
					action.payload.data.dominio,
					'descricao',
					'codigo',
				);
				draft.data = select;
				break;
			}
			case Types.TIPOS_CHAVE_PIX_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.TIPOS_CHAVE_PIX_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
